import { Component, HostListener, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'shared-customer-link',
    standalone: true,
    imports: [RouterLink],
    template: `
        @if (resolvedId) {
            <a [routerLink]="['/cu-customers', resolvedId, 'edit']"
               target="_blank"
               rel="noopener"
               class="link-primary link-underline-opacity-25 link-underline-opacity-100-hover">
                #{{ resolvedId }} — {{ displayName }}
            </a>
        } @else {
            {{ displayName }}
        }
    `,
})
export class CustomerLink {
    @Input() customer?: { id?: string | number | null; name?: string | null } | null;
    @Input() customerId?: string | number | null;
    @Input() customerName?: string | null;

    get resolvedId(): string | number | null {
        return this.customerId ?? this.customer?.id ?? null;
    }

    get displayName(): string {
        const name = this.customerName ?? this.customer?.name;
        if (name === undefined || name === null || name === '') {
            return '---';
        }

        return String(name);
    }

    @HostListener('click', ['$event'])
    onClick(event: Event): void {
        event.stopPropagation();
    }
}
